import { render, staticRenderFns } from "./PreviewFormsRQS.vue?vue&type=template&id=865aa8c4"
import script from "./PreviewFormsRQS.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsRQS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports